var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentWrapper',[_c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.managers),function(manager,i){return _c('v-col',{key:i,attrs:{"cols":"12","sm":"12","lg":"4"}},[_c('Manager',{attrs:{"manager":manager}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }